import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import Swal from 'sweetalert2';
import { IUnidadeGestoraModel } from "../../../models/unidade-gestora.model";
import { OsaService } from "../../../services/osa.service";


@Component({
	selector: "app-modal-incluir-ug-component",
	templateUrl: "./modal-vincular-ug-component.component.html",
	styleUrls: ["./modal-vincular-ug-component.component.scss"],
})
  export class ModalVincularUgComponentComponent implements OnInit {
    public dataSourceUG =
      new MatTableDataSource<any>([]);
    public unidadesGestoras: any[];
    public ugsSelecionadas: IUnidadeGestoraModel[] = [];
    public planejamentoId: number;

    statusError: string = '';

    public form = new FormGroup({
      ug: new FormControl("", Validators.required)
    });

    constructor(
      public matDialog: MatDialog,
      private osaService: OsaService,
      private dialogRef: MatDialogRef<ModalVincularUgComponentComponent>,
      @Inject(MAT_DIALOG_DATA) public data,
    ) {
      this.unidadesGestoras = data?.data?.unidadesGestoras;

    }

   async ngOnInit() {

    }

  public salvar() {

    if (!this.ugsSelecionadas || this.ugsSelecionadas.length === 0) {
      this.statusError = 'É obrigatório selecionar pelo menos uma unidade gestora.';
      return;
    }
    this.statusError = '';
    this.dialogRef.close(this.ugsSelecionadas);
  }

  public onSelectionChange() {
    if (this.ugsSelecionadas && this.ugsSelecionadas.length > 0) {
      this.statusError = '';
    }
  }
  public compareUgs(ug1: IUnidadeGestoraModel, ug2: IUnidadeGestoraModel): boolean {
    return ug1 && ug2 ? ug1.id === ug2.id : ug1 === ug2;
  }
  public trackByUgId(index: number, item: IUnidadeGestoraModel): number {
    return item.id;
  }
    public cancelar() {
      this.dialogRef.close();
    }

  }
